import { h, resolveComponent } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { ActiveUser } from "@/services/user";
import { IS_MZ_BRANDING } from "@/constants/config";

// Containers
const TheContainer = () => import("@/containers/TheContainer");
const AccountContainer = () => import("@/containers/AccountContainer");

// Views - Pages
const uploadPage = () => import("./views/upload_page/uploadPage.vue");
// const History = () => import("./views/history/History.vue");

const Page404 = () => import("@/views/pages/Page404");
const Login = () => import("@/views/pages/Login");
const ForgotPassword = () => import("@/views/pages/ForgotPassword");
const ResetPassword = () => import("@/views/pages/ResetPassword");

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes: configRoutes(),
});

const isOpenAccess = (route) =>
  route.matched.some((route) => route.meta?.isOpenAccess);

const isFound = (route) => {
  console.log();

  route.matched[0].name !== "NotFound";
};

router.beforeEach((to, from, next) => {
  if (to.meta?.getTitle) to.meta.title = to.meta.getTitle(to);
  const isAuthenticated = ActiveUser.get();
  if (!isAuthenticated && !isOpenAccess(to)) {
    if (isFound(to)) {
      localStorage.setItem("pathToLoadAfterLogin", to.path);
    }
    return next({ name: IS_MZ_BRANDING ? "Login" : "Management Login" });
  }
  return next();
});
export default router;

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/upload",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "upload",
          name: "Upload",
          component: uploadPage,
        },
        // {
        //   path: "history",
        //   name: "History",
        //   component: History,
        // },
      ],
    },
    {
      path: "/oauth",
      meta: {
        isOpenAccess: true,
      },
      component: AccountContainer,
      children: [
        {
          path: "",
          name: "OAuth Login",
          component: Login,
        },
      ],
    },
    {
      path: "/account",
      name: "account",
      meta: {
        isOpenAccess: true,
      },
      component: AccountContainer,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "forgot",
          name: "Forgot password",
          component: ForgotPassword,
        },
        {
          path: "reset/:token",
          name: "Password reset",
          component: ResetPassword,
        },
        {
          path: "login_management",
          name: "Management Login",
          component: Login,
          props: {
            show_email_login: true,
          },
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render() {
          return h(resolveComponent("router-view"));
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      component: TheContainer,
      children: [
        {
          path: "",
          name: "NotFound",
          component: Page404,
        },
      ],
    },
  ];
}
